import React, { useState, useCallback, useEffect, useRef } from 'react';
import axios from 'axios';
const CodeMozoee = (searchText, metheod) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [subjectsArray, setSubjectsArray] = useState([]);
  // const [,set]=useState([]);
  const [hasMore, setHaseMore] = useState(false);
  useEffect(() => {
    // console.log(hasMore)
    setLoading(true);
    setError(false);
    let cancel: any;
    axios({
      method: 'GET',

      url: `${
        process.env.REACT_APP_BASE_URL
      }/api/Data/Subjects?search=${searchText}${
        metheod !== null ? '&metheod=' + metheod : ''
      }`,
      // params:{page:pageNumber,search:searchText},
      cancelToken: new axios.CancelToken((c) => (cancel = c)),
    })
      .then((res) => {
        setSubjectsArray((prevSubs) => {
          return new Set([
            ...prevSubs,
            ...res.data.map((i) => {
              return { label: i.title, value: i.id };
            }),
          ]);
        });
        // console.log(Array.from(res.data).length > 1 ? true : false);

        // console.log('res', res);

        if (Array.from(res.data).length > 1) {
          setHaseMore(true);
        } else {
          setHaseMore(false);
        }

        setLoading(false);
        // console.log(res.data)
      })
      .catch((e) => {
        if (axios.isCancel(e)) return setError(e);
      });
    return () => cancel();
    // fetch(
    //   ` http://85.198.9.88:8080/api/Data/metheod?exec=true&size=25&page=${pageNumber}&search=${searchText}`,{ signal: abortController.abort() }
    // )
    //   .then((res) => res.json())
    //   .then((data) => console.log(data))
    //   return () =>
    //     abortController.abort(); // Cancel the request if component unmounts
  }, [searchText, metheod]);
  useEffect(() => {
    setSubjectsArray([]);
  }, [searchText]);
  return { loading, error, subjectsArray, hasMore };
};

export default CodeMozoee;
